import CardPerson from "./_components/card-person";

export default CardPerson;
